import { mergeAttributes, nodeInputRule } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import ImageResizeComponent from './ImageResizeComponent'
import Image from '@tiptap/extension-image'

export const inputRegex = /(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/
export const CustomImage = Image.extend({
  name: 'customImage',
  addOptions() {
    return {
      inline: false,
      allowBase64: false,
      HTMLAttributes: {},
      resizeIcon: <>⊙</>,
      imageAlign: 'left',
      useFigure: false,
    }
  },
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      ...this.parent?.(),
      src: {
        default: null,
        parseHTML: (element) => {
          return element.querySelector('img').getAttribute('src')
        },
      },
      textAlign: {
        default: 'flex-start',
        parseHTML: (element) => {
          const map = {
            'flex-start': 'left',
            center: 'center',
            'flex-end': 'right',
          }
          return map[element.style?.justifyContent || 'flex-start']
        },
        renderHTML: (attributes) => {
          if (attributes.textAlign === this.options.defaultAlignment) {
            return {}
          }
          const map = {
            left: 'flex-start',
            center: 'center',
            right: 'flex-end',
          }

          return {
            containerStyle: `justify-content: ${map[attributes.textAlign]}`,
          }
        },
      },
      width: {
        default: '',
        parseHTML: (element) => {
          return (
            Number(element.querySelector('img').getAttribute('width')) || ''
          )
        },
        renderHTML: (attributes) => {
          return {
            width: attributes.width,
          }
        },
      },
      height: {
        default: 'auto',
        parseHTML: (element) => {
          return Number(element.querySelector('img').getAttribute('height'))
        },
        renderHTML: (attributes) => {
          return {
            height: attributes.height,
          }
        },
      },
      borderRadius: {
        default: '0px',
        parseHTML: (element) => {
          return element.querySelector('img').style.borderRadius
        },
        renderHTML: (attributes) => {
          return {
            style: `border-radius: ${attributes.borderRadius}`,
          }
        },
      },
    }
  },
  parseHTML() {
    return [
      {
        tag: 'div',
        getAttrs: (element) => {
          return element.getAttribute('class') === 'image-container'
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    const containerStyle = HTMLAttributes.containerStyle
    delete HTMLAttributes.containerStyle
    return [
      'div',
      { class: 'image-container', style: containerStyle },
      ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)],
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageResizeComponent)
  },
  addCommands() {
    return {
      ...this.parent?.(),
      setImageAlign:
        (align) =>
        ({ commands }) => {
          commands.updateAttributes('customImage', { imageAlign: align })
        },
    }
  },
  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: (match) => {
          const [, , alt, src, title, height, width, isDraggable] = match
          return { src, alt, title, height, width, isDraggable }
        },
      }),
    ]
  },
})

export default CustomImage
